<div class="relative">
  <tui-loader [overlay]="true" [showLoader]="loading">
    <div class="container">
      <div class="flex gap-3 border-b border-b-[#bb0021] pb-2">
        <button style="cursor: pointer" class="p-2" (click)="router.navigate(['/admin/inventory'])">
          <tui-svg src="tuiIconArrowLeftCircleLarge" style="color: black"
            class="hover:scale-110 transition-all duration-100"></tui-svg>
        </button>
        <p class="flex items-center text-black text-[1.5rem] font-bold">
          {{ isEditMode ? 'Edit' : 'Add' }} Inventory
        </p>
      </div>
      <div class="flex items-center justify-center xl:justify-normal mt-5 2xl:my-10 lg:ml-10">
        <div class="w-full sm:w-[400px]">
          <form [formGroup]="form" (ngSubmit)="submit()">
            <div>
              <label for="itemName" class="text-black">Enter Item Name</label>
              <tui-input formControlName="itemName" tuiTextfieldSize="l" [tuiTextfieldCleaner]="true"
                [tuiTextfieldLabelOutside]="true" [style.text-align]="'left'" class="tui-space_top-1">
                Item Name
                <input autocomplete="itemName" tuiTextfield type="text" />
              </tui-input>
              <tui-error formControlName="itemName" [error]="[] | tuiFieldError | async"></tui-error>
            </div>
            <div class="mt-4">
              <label for="quantity" class="text-black">Enter Quantity</label>
              <tui-input formControlName="quantity" tuiTextfieldSize="l" [tuiTextfieldCleaner]="true"
                [tuiTextfieldLabelOutside]="true" [style.text-align]="'left'" class="tui-space_top-1">
                Quantity
                <input autocomplete="quantity" tuiTextfield type="number" />
              </tui-input>
              <tui-error formControlName="quantity" [error]="[] | tuiFieldError | async"></tui-error>
            </div>
            <div class="mt-4">
              <label for="price" class="text-black">Enter Price (LKR)</label>
              <tui-input formControlName="price" tuiTextfieldSize="l" [tuiTextfieldCleaner]="true"
                [tuiTextfieldLabelOutside]="true" [style.text-align]="'left'" class="tui-space_top-1">
                Price
                <input autocomplete="price" tuiTextfield type="number" />
              </tui-input>
              <tui-error formControlName="price" [error]="[] | tuiFieldError | async"></tui-error>
            </div>
            <div class="flex gap-3 w-full mt-5">
              <div class="w-full h-full">
                <button (click)="cancel()" tuiButton appearance="secondary" type="button" class="w-full h-full text-[#bb0021] hover:bg-[#faf0f2] hover:text-[#bb0021]">
                  Cancel
                </button>
              </div>
              <div class="w-full">
                <button tuiButton type="submit" [disabled]="loading" class="mt-6 w-full">
                  <span class="text-white">{{ isEditMode ? 'Update' : 'Add' }} Inventory</span>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </tui-loader>
</div>